module.exports = new __parcel__URL__("contact_email_icon.da0b4559.svg").toString();